import { Base } from "./base";

import { addDays } from "date-fns";
import { formatTimestamp } from "../utils/helper";
export class Analytics extends Base {
  #getURLWithQueryString(endpoint, { room, machine, startTs, stopTs }) {
    const url = new URL(this._getFullURL(endpoint));
    const params = {};
    if (machine) {
      params.machine = machine;
    }
    if (room) {
      params.room = room;
    }
    if (startTs) {
      params["start_ts"] = startTs;
    }
    if (stopTs) {
      let newStop = stopTs;
      if (stopTs === startTs) {
        let date = addDays(new Date(stopTs * 1000), 1);
        newStop = formatTimestamp(date);
      }
      params["stop_ts"] = newStop;
    }
    url.search = new URLSearchParams(params).toString();
    return url;
  }

  getTeamAnalytics(payload) {
    const url = this._getFullURL(`/analytics/work-order-analytics`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
  getFaults() {
    const url = this._getFullURL(`/analytics/get-list-fault`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        method: "POST",
      })
    );
  }
  getPartAnalytics(payload) {
    const url = this._getFullURL(`/analytics/part-analytics`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: payload,
        method: "POST",
      })
    );
  }
}
